import { ActivityLogMaintenanceConstant } from "presentation/constant/ActivityLog/ActivityLogMaintenanceConstant";
import { ActivityLogSearchCriteria } from "presentation/constant/ActivityLog/ActivityLogSearchCriteria";
import { useActivityLogMaintenanceVM } from "presentation/hook/ActivityLog/useActivityLogMaintenanceVM";
import { useActivityLogMaintenanceTracked } from "presentation/store/ActivityLog/ActivityLogMaintenanceProvider";
import { CriteriaItemContainer } from "presentation/view/components/CriteriaItemContainer";
import DateTimePickerComponent from "presentation/view/components/DateTimePickerComponent";
import { NbisCommonField } from "presentation/view/components/NbisCommonField";
import NbisDateTimePickerComponent from "presentation/view/components/NbisDateTimePickerComponent";
import { useCallback, useMemo, useState } from "react";
import { FieldType, HPHButton, IconButton, IFieldValue, Loader } from "veronica-ui-component/dist/component/core";
import { SidebarActionBar, SidebarActionCross, Sidebarheader, SidebarTitle } from "veronica-ui-component/dist/component/core/styled/uiFramework.styled";

export const ActivityLogSearchPanel = () => {
    const [activityLogState] = useActivityLogMaintenanceTracked();
    const activityLogVM = useActivityLogMaintenanceVM();
    const { searchCriteria } = activityLogState;
    const SCREEN_CONSTANT = ActivityLogMaintenanceConstant;
    const [isLoading, setIsLoading] = useState<boolean>(false);

    const resetButtonClicked = useCallback(() => {
        activityLogVM.onRemoveAllSearchCriteria();
    }, [activityLogVM]);

    const searchButtonClicked = useCallback((criteria: ActivityLogSearchCriteria) => {
        setIsLoading(true);
        activityLogVM.onSearch(criteria).then((data) => {
            setIsLoading(false);
        }).catch(error => {
            setIsLoading(false);
        })
    }, [activityLogVM]);

    const memoProcessId = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "150px", marginBottom: "24px" }}>
            <NbisCommonField
                errorMessages={{}}
                isReadOnly={false}
                isShowOptional={false}
                readOnlyValue={searchCriteria.processId || ''}
                fieldValue={searchCriteria.processId || ''}
                fieldLabel={SCREEN_CONSTANT.PROCESS_ID}
                isSaveClicked={false}
                fieldType={FieldType.TEXT}
                fieldKey={'processId'}
                maxLength={100}
                isTextFieldCapitalize={false}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    activityLogVM.onSearchFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [searchCriteria?.processId, SCREEN_CONSTANT.PROCESS_ID, activityLogVM])

    const memoLoggedBy = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "150px", marginBottom: "24px" }}>
            <NbisCommonField
                errorMessages={{}}
                isReadOnly={false}
                isShowOptional={false}
                readOnlyValue={searchCriteria.loggedBy || ''}
                fieldValue={searchCriteria.loggedBy || ''}
                fieldLabel={SCREEN_CONSTANT.LOGGED_BY}
                isSaveClicked={false}
                fieldType={FieldType.TEXT}
                fieldKey={'loggedBy'}
                maxLength={100}
                isTextFieldCapitalize={false}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    activityLogVM.onSearchFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [searchCriteria?.loggedBy, SCREEN_CONSTANT.LOGGED_BY, activityLogVM])

    const memoFromDate = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "330px", marginBottom: "24px" }}>
            {/* <DateTimePickerComponent
                label={SCREEN_CONSTANT.LOG_DATE_RANGE}
                width='330px'
                fieldNames={{ startField: "logDateFrom", endField: "logDateTo" }}
                dateRange={{ startDate: searchCriteria.logDateFrom, endDate: searchCriteria.logDateTo }}
                onDatesChange={activityLogVM.onDateRangeChange}
            /> */}
            <NbisDateTimePickerComponent
                disabled={false}
                label={SCREEN_CONSTANT.LOG_DATE_TIME_FROM}
                width="330px"
                date={searchCriteria?.logDateFrom ?? null}
                fieldName="logDateFrom"
                onDateChange={(fieldKey: string, fieldValue: IFieldValue) =>
                    activityLogVM.onSearchFieldChange(fieldKey, fieldValue)} />
        </div>
        , [SCREEN_CONSTANT.LOG_DATE_TIME_FROM, activityLogVM, searchCriteria?.logDateFrom])
    const memoToDate = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "330px", marginBottom: "24px" }}>
            {/* <DateTimePickerComponent
                label={SCREEN_CONSTANT.LOG_DATE_RANGE}
                width='330px'
                fieldNames={{ startField: "logDateFrom", endField: "logDateTo" }}
                dateRange={{ startDate: searchCriteria.logDateFrom, endDate: searchCriteria.logDateTo }}
                onDatesChange={activityLogVM.onDateRangeChange}
            /> */}
            <NbisDateTimePickerComponent
                disabled={false}
                label={SCREEN_CONSTANT.LOG_DATE_TIME_TO}
                width="330px"
                date={searchCriteria?.logDateTo ?? null}
                fieldName="logDateTo"
                onDateChange={(fieldKey: string, fieldValue: IFieldValue) =>
                    activityLogVM.onSearchFieldChange(fieldKey, fieldValue)} />
        </div>
        , [SCREEN_CONSTANT.LOG_DATE_TIME_TO, activityLogVM, searchCriteria?.logDateTo])

    const memoMessage = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "330px", marginBottom: "24px" }}>
            <NbisCommonField
                errorMessages={{}}
                isReadOnly={false}
                isShowOptional={false}
                readOnlyValue={searchCriteria.message || ''}
                fieldValue={searchCriteria.message || ''}
                fieldLabel={SCREEN_CONSTANT.MESSAGE}
                isSaveClicked={false}
                fieldType={FieldType.TEXT}
                fieldKey={'message'}
                maxLength={100}
                isTextFieldCapitalize={false}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    activityLogVM.onSearchFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [SCREEN_CONSTANT.MESSAGE, searchCriteria?.message, activityLogVM])


    return <div className='side-form-content-left-wrapper' style={{ padding: "20px 20px 20px 0px" }}>
        <div className={'flex-row'}>
            <div className={'flex-row-item flex-row-item-full-width'}>
                <Sidebarheader>
                    <SidebarTitle>{'Search Criteria'}</SidebarTitle>
                    <SidebarActionCross>
                        <IconButton
                            fileName="Icon-cross" size="medium" toolTipText='Close' toolTipArrow={false} onClick={activityLogVM.onToggleCriteriaPanel} />
                    </SidebarActionCross>
                </Sidebarheader>
            </div>
        </div>

        {isLoading && <Loader Indicator="Spinner" size="Medium" />}

        <div className={'add-edit-form'} style={{ height: '75vh', maxHeight: '75vh', overflow: 'auto' }}>
            <div className="flex-row-auto">
                <div className={'flex-row-item'}>

                    {/* Stack Form Start */}
                    <CriteriaItemContainer>
                        {memoProcessId}
                        {memoLoggedBy}
                    </CriteriaItemContainer>
                    <CriteriaItemContainer>
                        {memoFromDate}
                    </CriteriaItemContainer>
                    <CriteriaItemContainer>
                        {memoToDate}
                    </CriteriaItemContainer>
                    <CriteriaItemContainer>
                        {memoMessage}
                    </CriteriaItemContainer>
                </div>
            </div>
        </div>
        <SidebarActionBar>
            <HPHButton label={'Reset'} size={'Small'} theme={'Secondary'} onClick={resetButtonClicked} />
            <HPHButton label={'Search'} size={'Small'} theme={'Primary'} onClick={() => searchButtonClicked(searchCriteria)} />
        </SidebarActionBar>
    </div>
}
